import React from "react";

function VNeck1() {
  return (
    <path
      d="m 389.02291,501.4236 14.39852,14.41794 c -97.32625,30.33922 -203.07802,3.5655 -296.33794,-3.08432 2.29138,-2.14934 13.19185,-16.11472 25.29386,-27.21356 3.21929,-2.65118 6.62796,-5.17927 10.15023,-7.63161 7.49167,-5.13256 15.37839,-9.66323 23.58605,-13.54944 6.62796,-3.14353 26.7012,-7.39489 39.69197,-12.40373 v 22.51611 l 37.87402,31.24607 c 5.08965,4.213 12.4555,4.213 17.54515,0 l 37.87401,-31.24607 v -30.58327 c 8.06717,9.89458 20.83071,10.99292 35.24178,17.69663 10.17341,4.6936 19.89692,10.30649 29.04938,16.76874 2.96047,2.07674 5.80102,4.22924 8.52164,6.4575 2.78373,2.2535 12.27485,12.5106 17.11133,16.60901 z"
      id="path567"
      style={{ fill: "#3e436d", strokeWidth: "0.94685" }}
    />
  );
}

export default VNeck1;
